module.exports = __webpack_public_path__ + "img/IS610269-6569.cc5374cf.png";